import React, { Component } from "react";
import { ENGLISH, ARABIC } from "../../shared/supportedLanguages";
import "./WelcomeScreenComponent.css";
import logoImg from "../../assets/images/logo.svg";
import btnImg from "../../assets/images/Group 427.png";
import welcomeSlogan from "../../assets/images/welcomeSlogan.svg";
// import useCookies from '@react-smart/react-cookie-service';
import closeIcon from "../../assets/images/icons8-close.svg";
import agentImage from "../../assets/images/logo.svg";

export default class WelcomeScreen extends Component {
  constructor(props) {
    super(props);
    window.addEventListener(
      "startChatbotEnglish",
      () => this.handleStartChatBotEnglish(),
      false
    );
    window.addEventListener(
      "startChatbotArabic",
      () => this.handleStartChatBotArabic(),
      false
    );
  }
  clearTokens() {
    if (localStorage.getItem("botToken")) {
      localStorage.removeItem("botToken");
    }
  }
  componentDidMount() {
    if (localStorage.getItem("conversationId")) {
      this.handelStartWithLang("en-us");
    }
    this.clearTokens();
  }

  handleStartChatBotEnglish() {
    this.props.startBotWithLanguage(ENGLISH);
  }

  handleStartChatBotArabic() {
    this.props.startBotWithLanguage("ar-jo");
  }
  // Handel Start With Lang
  handelStartWithLang = (lang) => {
    if (lang === ARABIC) {
      this.handleStartChatBotArabic();
      this.props.onOpenChat(lang);
    } else {
      this.handleStartChatBotEnglish();
      this.props.onOpenChat(lang);
    }

    window.parent.postMessage("hideCloseButton", "*");

    // return  this.props.onOpenChat(lang);
  };
  // getLangInCockie() {
  //   const { getCookie } = useCookies();
  //   return getCookie("botLanguage") || "en";
  // }

  render() {
    return (
      //     <iframe id="welcomeScreen" style={{height:'100%', width:'100%'}} marginWidth="0" marginHeight="0" scrolling="No"
      //         frameBorder="0" hspace="0" vspace="0" title="welcomeScreen" src={'./WelcomeScreen.html'} sandbox="allow-modals allow-same-origin allow-scripts allow-popups allow-forms">
      // </iframe>
      <div className="welcome">
        <img
          src={agentImage}
          style={{
            width: "60px",
            marginInline: "10px",
            cursor: "pointer",
            position: "absolute",
            top: "0px",
            left: "0px",
          }}
        />
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <img
            onClick={() => window.parent.postMessage("closeIframe", "*")}
            src={closeIcon}
            style={{
              width: "20px",
              marginInline: "10px",
              cursor: "pointer",
            }}
          />
          {/* <img
            onClick={() => window.parent.postMessage("MinusIframe", "*")}
            src={minusIcon}
            style={{
              width: "20px",
              marginInline: "10px",
              cursor: "pointer",
            }}
          /> */}
        </div>
        <div className="logo">
          <img src={logoImg} />
        </div>
        {localStorage.getItem("lang") === "en" ? (
          <div className="text">
            <div style={{ direction: "rtl" }}>
              <p className="ar">
                مرحبا بك في هيئة أبوظبي للزراعة والسلامة الغذائية
              </p>
              <p className="ar">
                اسمي خالد وهدفي هو مساعدتك للوصول إلى ما تحتاج إليه
              </p>
              <p className="ar">الرجاء اختيار لغتك المفضلة</p>
            </div>
            <p>
              Hello! Welcome to Abu Dhabi Agriculture & Food Safety Authority
              (ADAFSA).
            </p>
            <p>I’m khaled and I am here to assist you.</p>
            <p>Please select your preferred language</p>
          </div>
        ) : (
          <div className="text">
            <div style={{ direction: "rtl" }}>
              <p className="ar">
                مرحبا بك في هيئة أبوظبي للزراعة والسلامة الغذائية
              </p>
              <p className="ar">
                اسمي خالد وهدفي هو مساعدتك للوصول إلى ما تحتاج إليه
              </p>
              <p className="ar">الرجاء اختيار لغتك المفضلة</p>
            </div>
            <p>
              Hello! Welcome to Abu Dhabi Agriculture & Food Safety Authority
              (ADAFSA).
            </p>
            <p>I’m khaled and I am here to assist you.</p>
            <p>Please select your preferred language</p>
          </div>
        )}

        <div className="actions" style={{ marginTop: "30px" }}>
          {/* <button onClick={(e)=> this.handelStartWithLang(e, ENGLISH)}>Let's Talk</button>
                    <button onClick={(e)=> this.handelStartWithLang(e, ARABIC)}>دعنا نتحدث</button> */}
          <button
            onClick={() => this.handelStartWithLang("en-us")}
            className="startBtn"
            id="startBtn"
          >
            <span>Let's Talk</span>
            {/* <img src={btnImg} alt="button" style={{ right: "6px" }} /> */}
          </button>
          <button
            onClick={() => this.handelStartWithLang("ar-jo")}
            className="startBtn"
          >
            {/* <img src={btnImg} alt="زر" style={{ left: "6px" }} /> */}
            <span style={{ fontFamily: "droid-arabic-kufi" }}>دعنا نتحدث</span>
          </button>
        </div>
        <div className="version">
          <p>{process.env.REACT_APP_VERSION}</p>
        </div>
      </div>
    );
  }
}
